export const MEETING_STATUS_WAITING = Symbol('Not open for registration yet');
export const MEETING_STATUS_OPEN = Symbol('Open for registration');
export const MEETING_STATUS_ASSIGNED = Symbol('Meeting time assigned');
export const MEETING_STATUS_CLOSED = Symbol('Registration close');

// Actions in Planner onChange

const MEETING_GENERAL_FIELDS = ['title', 'description', 'duration', 'inBetween', 'groups', 'meetingLocationType'];
const MEETING_REGISTRATION_FIELDS = ['registerStart', 'registerEnd', 'announcementInDays', 'announcementFlag'];
export const MEETING_ALL_FIELDS = [...MEETING_GENERAL_FIELDS, ...MEETING_REGISTRATION_FIELDS, 'id', 'meetings', 'blocks', 'complete'];

export const SLOT_OPEN = 0;
export const SLOT_BREAK = 1;
export const SLOT_BLOCKED = 2;
export const SLOT_ASSIGNED = 3;

export const SLOT_CLASSNAMES = ['slot-open', 'slot-break', 'slot-blocked', 'slot-assigned'];

export const SLOT_ACTIONS = {
  makeMeeting: SLOT_OPEN,
  makeBreak: SLOT_BREAK,
  assign: SLOT_ASSIGNED,
  unassign: SLOT_OPEN,
  block: SLOT_BLOCKED,
  unblock: SLOT_OPEN,
};
